import BasicInitializationService from "../../services/initialization/basicInitializationService";
import makeWidgetFor from "../../viewModels/makeWidgetFor";
import { registerWidget } from "../widget";
import PriceListViewModel from "viewModels/common/priceListViewModel";

const PriceListWidgetIdentifier = "edaz-price-list";

registerWidget({
  component: makeWidgetFor(PriceListWidgetIdentifier, [PriceListViewModel], BasicInitializationService),
  configuration: {
    tagname: PriceListWidgetIdentifier,
  },
});
